import { useEffect } from 'react'

import { bootstrapMissingPreviewPage } from '../helpers/bootstrapMissingPreviewPage'
import { isContentfulPreviewFrame } from '../helpers/isContentfulPreviewFrame'
import { refreshGatsbyContentful } from '../helpers/refreshGatsbyContentful'

/**
 * POC: if Contentful Live Preview opens a slug that Gatsby develop has not created yet,
 * re-source Contentful and reload once the route's page-data exists.
 */
export const useBootstrapMissingPreviewPage = (): void => {
  useEffect(() => {
    if (!isContentfulPreviewFrame()) return

    let cancelled = false

    bootstrapMissingPreviewPage({
      pathname: window.location.pathname,
      isPreviewFrame: true,
      refresh: refreshGatsbyContentful,
      reload: () => {
        if (!cancelled) window.location.reload()
      },
    }).catch(error => {
      console.error('[contentful-preview-bootstrap] unexpected error', error)
    })

    return () => {
      cancelled = true
    }
  }, [])
}
